import { useEffect, useState } from 'react';
import { Topbar, Sidebar, Loader, PaymentOverview } from "../../components";
import Table from './Table';
import { Tab, TabGroup, TabList, TabPanel, TabPanels } from '@headlessui/react';
import { usePayments } from '../../hooks';
import Report from './Report';
import { HugeiconsIcon } from '@hugeicons/react';
import { Money01Icon, Download01Icon } from '@hugeicons/core-free-icons';

const TAB_STYLE = ({ selected }) =>
    `shrink-0 px-6 py-3.5 text-sm font-medium border-b-2 -mb-px transition-colors focus:outline-none whitespace-nowrap ${
        selected
            ? 'border-[#1e3a6e] text-[#1e3a6e] dark:border-white dark:text-white'
            : 'border-transparent text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-200 hover:border-gray-300 dark:hover:border-gray-600'
    }`;

function Index() {

    const { isLoading, payments } = usePayments();
    const [isOpen, setIsOpen] = useState(false);
    const [loading, setLoading] = useState(false);
    const [transactions, setTransactions] = useState([]);

    const loadingState = isLoading || loading;

    useEffect(() => {
        document.title = `Payment Transactions - ${process.env.REACT_APP_SITE_NAME}`;
    }, []);

    return (
        <>
        <div className='main-container'>
            <Topbar />
            <Sidebar />

            <main className='main-content'>
                <section className='section-container space-y-6'>

                    <div className="flex items-center justify-between">
                        <div className="flex items-center gap-3">
                            <div className="w-9 h-9 rounded-xl bg-blue-50 border border-blue-100 flex items-center justify-center shrink-0">
                                <HugeiconsIcon icon={Money01Icon} size={18} className="text-[#1e3a6e]" />
                            </div>
                            <div>
                                <h1 className="text-lg font-semibold text-gray-900 dark:text-gray-50 flex items-center gap-2">
                                    Payments
                                    {loadingState && <Loader color="text-gray-400" size="w-4 h-4" />}
                                </h1>
                                <p className="text-sm text-gray-400">Disbursements and repayment overview</p>
                            </div>
                        </div>

                        <button
                            type="button"
                            onClick={() => setIsOpen(true)}
                            className="inline-flex items-center gap-2 px-4 py-2 text-sm font-medium text-gray-700 dark:text-gray-200 border border-gray-200 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors shadow-sm"
                        >
                            <HugeiconsIcon icon={Download01Icon} size={15} className="text-gray-400" />
                            Generate Report
                        </button>
                    </div>

                    <TabGroup>
                        <TabList className="flex border-b border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 rounded-t-xl">
                            <Tab className={TAB_STYLE}>Overview</Tab>
                            <Tab className={TAB_STYLE}>Momo Transactions</Tab>
                        </TabList>

                        <TabPanels className="mt-0">
                            <TabPanel>
                                <PaymentOverview payments={payments} />
                            </TabPanel>
                            <TabPanel>
                                <Table
                                    transactions={transactions}
                                    setTransactions={setTransactions}
                                    setLoading={setLoading}
                                />
                            </TabPanel>
                        </TabPanels>
                    </TabGroup>

                </section>
            </main>
        </div>

        <Report isOpen={isOpen} closeModal={() => setIsOpen(false)} />
        </>
    );
}

export default Index;
